import { ReactNode } from 'react';

import { Box } from '@mui/material';

import Typography from '@/components/Typography';

interface EmptyStateProps {
  title: string;
  description: string;
  icon: ReactNode;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const EmptyState = ({ title, description, icon, setOpen }: EmptyStateProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: 3,
        border: '2px dashed',
        borderColor: 'gx.textDisabled',
        cursor: setOpen ? 'pointer' : undefined,
        userSelect: 'none'
      }}
      onClick={() => {
        setOpen?.(true);
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'gx.textDisabled',
          marginBottom: 2
        }}
      >
        {icon}
      </Box>

      <Typography
        size={12}
        sx={{
          color: 'gx.textDisabled'
        }}
      >
        {title}
      </Typography>

      <Typography
        size={12}
        sx={{
          color: 'gx.textDisabled'
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};
